import type { LooseColumn } from "../types";

export const getLooseColumnKey = <T extends object>(col: LooseColumn<T>) => String(col.key ?? col.dataIndex ?? "");

export const getLooseDataIndex = <T extends object>(col: LooseColumn<T>) => col.dataIndex;

export const getLooseSorter = <T extends object>(col: LooseColumn<T>) => col.sorter;

export const getLooseEllipsis = <T extends object>(col: LooseColumn<T>) => col.ellipsis;

export function toValueArray(value: unknown): string[] {
	if (value == null) {
		return [];
	}

	if (Array.isArray(value)) {
		return value.flatMap((item) => toValueArray(item));
	}

	if (typeof value === "object") {
		const item = value as Record<string, unknown>;
		if (typeof item.name === "string") {
			return [item.name.trim()];
		}
		return [];
	}

	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed ? [trimmed] : [];
	}

	return [String(value)];
}

export function getColumnValue<T extends object>(row: T, dataIndex: unknown): unknown {
	if (Array.isArray(dataIndex)) {
		return dataIndex.reduce<unknown>((acc, key) => {
			if (!acc || typeof acc !== "object") {
				return undefined;
			}
			return (acc as Record<string, unknown>)[String(key)];
		}, row);
	}

	if (typeof dataIndex === "string") {
		return (row as Record<string, unknown>)[dataIndex];
	}

	return undefined;
}
